import BaseAPI from "./BaseAPI";

class TimeRegistrationAPI extends BaseAPI {
	
    getAll = async (data = null) => {
        var promise = await this.init().post("/account/timeregistration/get", data);
        return promise;
    };



    startTimeRegistration = async () => {
        var promise = await this.init().get("/account/timeregistration/startRegistration");
        return promise;
    };

    saveTimeRegistration = async (data) => {
        
        let newOrklogDate = data.getDatabaseDate(data.worklog_date);
        data = data.toJsonString();
        data.worklog_date = newOrklogDate;
        var promise = await this.init().post("/account/timeregistration", data);
        return promise;
    };

    deleteTimeRegistration = async (data) => {
        var promise = await this.init().delete("/account/timeregistration/"+data.key);
        return promise;
    };

    exportTimeRegistration = async (data) => {
        //data = data.toJsonString();
        var promise = await this.init().post("/account/timeregistration/export", data);
        return promise;
    };

    getInvoiceRegistrationForCustomer = async (data) => {
        //data = data.toJsonString();
        var promise = await this.init().post("/account/timeregistration/invoiceforcustomer", data);
        return promise;
    };

    startTimer = async (data) => {
        data = data.timer.getData();
        //data = data.toJsonString();
        var promise = await this.init().post("/account/timeregistration/timer/new", data);
        return promise;
    };

    stopTimer = async (data) => {
        data = data.timer.getData();
        //data = data.toJsonString();
        var promise = await this.init().post("/account/timeregistration/timer/stop", data);
        return promise;
    };

    pauseTimer = async (data) => {
        data = data.timer.getData();
        //data = data.toJsonString();
        var promise = await this.init().post("/account/timeregistration/timer/pause", data);
        return promise;
    };
	
}

export default new TimeRegistrationAPI();